import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  top: 0px;
  height: 100vh;
  background-color: #607d8b;
  align-items: center;
  justify-content: center;
  .grecaptcha-badge {
    visibility: hidden;
  }
  @media only screen and (max-width: 768px) {
    width: 100vw;
    //min-height: 100vh;
    //max-height: -webkit-fill-available;
    //overflow-y: scroll;
    flex-direction: column;

    .thisRecap {
      display: none;
    }
  }
`

export const Box = styled.div`
  background-color: #f2f3f3;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  @media only screen and (max-width: 768px) {
    /* min-height: 100%;
    max-height: 100%; */
    min-height: 100vh;
    max-height: 100vh;
    /* overflow-y: visible; */
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: fixed;
  }
`

export const BoxLeft = styled.div`
  width: 70vw;
  height: 100vh;
  display: flex;
  overflow: hidden;

  background: linear-gradient(54.21deg, #2c3789 0%, #159ed2 100%);

  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin-left: auto;
  padding-left: 200px;
  position: relative;

  .box_left_button {
    height: 40px;
    border-radius: 20px;
    border: 1px solid #ffffff;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    font: normal normal 500 14px/19px Roboto;
    background: transparent;
    color: #ffffff;
    align-self: flex-start;
    text-decoration: none;
  }

  .box_left_title {
    text-align: left;
    font: normal normal bold 64px/72px Roboto;
    letter-spacing: 0px;
    color: #ffffff;
    margin-bottom: 30px;
  }

  .box_left_small {
    text-align: left;
    font: normal normal 500 24px/32px Roboto;
    letter-spacing: 0px;
    color: #ffffff;
  }

  .box_left_subtitle {
    font-size: 20px;
    font-weight: 300;
    line-height: 30px;
    text-align: left;
    color: #ffffff;
  }
  .box_left_subtitle + .box_left_subtitle {
    margin-top: 16px;
  }

  .box_left_bold {
    font-weight: bold;
  }

  .box_left_footer {
    position: absolute;
    bottom: 24px;
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #ffffff;
  }

  .box_left_bottom_right_footer {
    position: absolute;
    bottom: 24px;
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: right;
    color: #ffffff;
    right: 32px;
    @media only screen and (max-width: 768px) {
      display: none;
    }
  }

  .align_self_start {
    align-self: flex-start;
  }
  .mb-15 {
    margin-bottom: 15px;
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .mb-32 {
    margin-bottom: 32px;
  }

  @media only screen and (max-width: 768px) {
    padding-left: 64px;
    padding-right: 64px;
    padding-top: 24px;
    padding-bottom: 80px;
    width: 100vw;
    justify-content: flex-start;
    display: flex;
    align-items: center;
    top: 0px;
    //min-height: 500px;
    overflow: visible;
    flex: 1;

    .box_left_title {
      font-size: 30px;
      line-height: 32px;
      color: #ffffff;
      text-align: center;
      font-weight: bold;
      font-family: Roboto;
      margin-bottom: 8px;
      font-size: 32px;
      font-weight: 700;
      line-height: 38.4px;
      text-align: center;
    }
    .box_left_subtitle {
      text-align: center;
      font-size: 16px;
      font-weight: 300;
      line-height: 24px;
      text-align: center;
    }

    .box_left_small {
      font-family: Roboto;

      font-size: 14px;
      line-height: 18px;
      font-weight: 300;

      color: #ffffff;
    }
    .box_left_footer {
      display: none;
    }
  }
`

export const BoxTwoImages = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 30px;
  max-height: 360px;
  #imgPhone {
    margin-top: -20px;
    margin-right: 100px;
    height: 340px;
  }
  #imgText {
    margin-top: 20px;
    height: 72px;
  }
  @media only screen and (max-width: 768px) {
    margin-top: 0px;
    max-height: 50px;

    #imgPhone {
      display: none;
      margin-top: 0px;
      height: 0px;
    }
    #imgText {
      margin-top: 5px;
      position: relative;
      margin-left: 0px;
      height: 40px;
    }
  }
`

export const BoxTextAndCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 410px;
  margin: 20px 0px 0px 0px;
  @media only screen and (max-width: 768px) {
    margin: 0px 0px 0px 0px;
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`

export const BoxRight = styled.div`
  width: 30vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #f0f0f0;
  padding-left: 0px;
  .box_right_footer_mobile {
    display: none;
  }

  a {
    text-decoration: none;
  }
  > div {
    #logoWeb {
      height: 100px;
      display: flex;
    }
    #logoMobile {
      //margin-bottom: 30px;
      height: 148px;
      display: none;
    }
  }

  .login_footer_link {
    position: absolute;

    bottom: 40px;
    // width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: 768px) {
      position: relative;
      padding-top: 40px;
      padding-bottom: 20px;
      border-bottom: 1px solid #676767;

      //display: none;
    }
  }

  .login_img_container {
    text-align: center;
    font: normal normal normal 14px/19px Roboto;
    letter-spacing: 0px;
    color: #ffffff;
    display: flex;
    align-items: center;
    flex-direction: column;

    margin-bottom: 40px;

    p {
      margin-top: 20px;
    }
  }

  .login_form_container {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 16px 16px 16px #22222229;
    border-radius: 36px;
    margin-left: -110px;
    max-width: 370px;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 60px;
    padding-bottom: 60px;
    position: relative;

    .ml-10 {
      margin-left: 10px;
    }

    .mt-60 {
      margin-top: 60px;
    }

    .pb-24 {
      padding-bottom: 24px;
    }
    .pb-30 {
      padding-bottom: 30px;
    }
    .pb-40 {
      padding-bottom: 40px;
    }
    .pb-72 {
      padding-bottom: 72px;
    }

    .pt-30 {
      padding-top: 30px;
    }
    .mb-24 {
      margin-bottom: 24px;
    }

    .bb-gray {
      border-bottom: 1px #f0f0f0 solid;
    }

    .login_form_title {
      margin: 0;
      margin-bottom: 5px;
      font-size: 24px;
      font-weight: 600;
      line-height: 28.8px;
      text-align: left;
      color: #212121;
      @media only screen and (max-width: 768px) {
        display: none;
      }
    }
    .login_form_title-mobile {
      display: none;
      @media only screen and (max-width: 768px) {
        display: block;
        font-size: 20px;
        font-weight: 600;
        line-height: 24px;
        text-align: left;
        color: #212121;
      }
    }
    .login_form_subtitle {
      text-align: left;
      font: normal normal normal 18px/26px Roboto;
      letter-spacing: 0px;
      color: #676767;
      margin-bottom: 20px;
      max-width: 80%;
    }

    .login_input_label {
      margin: 0;
      margin-bottom: 5px;
      text-align: left;
      font-size: 13px;
      font-weight: 400;
      line-height: 24px;
      text-align: left;
      letter-spacing: 0px;
      color: #212121;
    }

    .login_row {
      display: flex;
      flex-direction: row;
      align-items: center;
      //width: 100%;
    }

    .login_input_container {
      height: 40px;
      background-color: #ffffff;
      border-radius: 8px;
      border: 1px solid #9f9f9f;
      font: normal normal 300 16px/19px Roboto;
    }
    .login_input_password {
      height: 40px;
      background-color: transparent;
      //border-radius: 20px;
      font: normal normal 300 16px/19px Roboto;
      //border: transparent;
      border: 0;
    }

    .input_password_container {
      // width: 280px;

      height: 40px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      background: #ffffff;
      border: 1px solid #9f9f9f;
      font: normal normal 300 16px/19px Roboto;
      input {
        /*border-radius: 16px;
        //height: 48px;
        flex: 1;
        border: 0;
        padding-left: 16px;*/
      }

      .input_icon_container {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-right: 16px;
        cursor: pointer;
        height: 100%;
      }

      .input_password_icon {
        width: 17px;
        height: 17px;
      }
    }
  }

  .login_gap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .login_wait_image{
    width: 192px;
height: 128px;
gap: 0px;
opacity: 0px;

  }

  .mt-5 {
    margin-top: 5px;
  }

  .mt-30 {
    margin-top: 30px;
  }

  .mt-10 {
    margin-top: 10px;
  }
  .mt-15 {
    margin-top: 15px;
  }
  .mt-20 {
    margin-top: 20px;
  }

  .login_form_bottom_container {
    display: flex;
    flex-direction: column;
    align-items: center;

    a {
      text-decoration: none;
      color: #18aa36;
    }
  }

  .login_form_bottom_text {
    text-align: center;
    font: normal normal normal 14px/19px Roboto;
    letter-spacing: 0px;
    color: #676767;
  }

  @media only screen and (max-width: 768px) {
    background-color: #ffffff;

    > div {
      #logoWeb {
        height: 148px;
        display: none;
      }
      #logoMobile {
        height: 40px;
        width: 50vw;
        display: flex;
      }
    }
    display: flex;
    //padding: 10px;
    //width: 100%;
    //max-height: 65%;
    //min-height: 100vh;
    justify-content: center;
    align-items: center;
    //position: fixed;
    bottom: 0px;
    flex-direction: column;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

    //overflow-y: scroll;
    margin-left: 0px;
    width: 100vw;
    max-width: 100vw;
    //margin-top: -50px;
    .login_form_container {
      margin-left: 0;
      max-width: 100%;
      width: 100%;
      margin: 0;
      padding-top: 36px;
      padding-left: 52px;
      padding-right: 52px;
      margin-top: -72px;

      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      box-shadow: none;
    }

    .box_right_footer_mobile {
      display: flex;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      text-align: left;
      color: #212121;
      margin-bottom: 20px;
    }
  }
`

interface FormButtonProps {
  isFocused?: boolean
}

export const FormButton = styled.button<FormButtonProps>`
  background: ${(props) => (props.isFocused ? '#18aa36' : '#FFFFFF')};
  border: #18aa36 1px solid;
  border-radius: 8px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font: normal normal 500 14px/19px Roboto;
  color: ${(props) => (props.isFocused ? '#FFFFFF' : '#18AA36')};
  width: 100%;
  transition: all 0.2s;
  margin-top: 20px;
`

export const Title = styled.div`
  font-size: 26px;
  color: #536979;
  line-height: 34px;
  letter-spacing: -0.52px;
  font-family: 'Inter';
  font-weight: 800;
  @media only screen and (max-width: 768px) {
    font-size: 16px;
    text-align: center;
    color: #536979;
    line-height: 24px;
    letter-spacing: -0.52px;
    font-family: 'Inter';
    font-weight: 800;
  }
`

export const Description = styled.div`
  font-size: 18px;
  color: #536979;
  line-height: 26px;
  letter-spacing: -0.36px;
  font-family: 'Inter';
  font-weight: 400;
  @media only screen and (max-width: 768px) {
    text-align: center;
    font-size: 15px;
    line-height: 20px;
  }
`

export const Images = styled.div`
  width: 150px;
  /* background-color: red; */
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    margin-bottom: 0px;
  }
`

export const TextFoot = styled.div`
  font-size: 12px;
  color: #536979;
  letter-spacing: -0.24px;
  font-family: 'Inter';
  font-weight: 400;
  margin-left: 20px;
  font: normal normal normal 11px/16px Inter;
  letter-spacing: 0px;
  color: #536979;
  @media only screen and (max-width: 768px) {
    margin-top: 10px;
    margin-left: 0px;
    line-height: 14px;
    width: 200px;
  }
`

export const Label = styled.label`
  text-align: left;
  font: normal normal 500 12px/16px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  text-transform: uppercase;
  margin-bottom: 5px;
  @media only screen and (max-width: 768px) {
    /*font-size: 18px;
    text-align: center;
    margin-top: 0px;
    line-height: 22px;*/
  }
`
export const Input = styled.input`
  // width: 280px;
  height: 48px;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  text-align: left;
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  @media only screen and (max-width: 768px) {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`

export const Button = styled.button`
  width: 280px;
  height: 48px;
  border-radius: 16px;
  border: none;
  color: #fff;
  font-size: 16px;
  line-height: 19px;
  font-family: 'Inter';
  background-color: var(--primaryColor);
`

export const FormFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #212121;
  @media only screen and (max-width: 768px) {
    align-items: center;
    text-align: center;
  }
`

export const FormFooterWait = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #212121;
  .footer_link-a {
    font-weight: 600;
    color: #212121;
    text-decoration: underline;
    cursor: pointer;
  }
  @media only screen and (max-width: 768px) {
    align-items: center;
    text-align: center;
  }
`

export const FormFooterLink = styled.div`
  color: #212121;

  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  text-align: center;

  .footer_link-a {
    color: #212121;
    text-decoration: underline;
    cursor: pointer;
  }
`

export const ModeSelector = styled.div`
  background: #eeeeee;
  height: 40px;
  padding: 4px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-radius: 8px;
  cursor: pointer;
`

interface ModeSelectorItemProps {
  isActive?: boolean
}

export const ModeSelectorItem = styled.div<ModeSelectorItemProps>`
  ${({ isActive }) => css`
    border: none;
    background: ${isActive ? '#ffffff' : 'transparent'};
    height: 32px;

    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 14px;
    font-weight: ${isActive ? 500 : 400};
    line-height: 16px;
    text-align: center;
  `}
`

export const WaitTitle = styled.p`
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  line-height: 29px;
  text-align: center;
  color: #212121;
`
export const WaitInfo = styled.p`
  font-family: Inter;
  color: #212121;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  max-width: 286px;
`
